/**
 * Application-wide constants.
 */

export const APP_NAME = 'StagehandUI'

export const ROUTES = {
  HOME: '/',
  DELIVERIES: '/deliveries',
  RECEIVING: '/receiving',
  SETUP: '/setup',
} as const
